module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/eko-piknik/thumbs/3-3f4c601d6d1573368db51ed999fdc355.webp";